import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";
import { StaffRequestModel } from "../shared/StaffRequestModel";

@Injectable()
export class StaffService {
	constructor(private httpclientService: HttpclientService) {}

	private subject = new Subject<any>();
	studentSelectedChanged(person) {
		this.subject.next(person);
	}

	onsStudentSelectChange(): Observable<any> {
		return this.subject.asObservable();
	}

	StaffGets(personID) {
		var postResult$ = new Subject();
		// var url='StaffSelector/StaffGets?PersonID=' + personID;
		var url = "StaffSelector/StaffSelectInfo?PersonID=" + personID;

		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StaffTypeSelectList() {
		var postResult$ = new Subject();
		var url = "Staff/StaffTypeSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EthnicitySelectList() {
		var postResult$ = new Subject();
		var url = "Staff/EthnicitySelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StaffInsert(parms: StaffRequestModel) {
		var postResult$ = new Subject();
		var url = "Staff/StaffInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StaffUpdate(parms: StaffRequestModel) {
		var postResult$ = new Subject();
		var url = "Staff/StaffUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StaffIDInUse(StaffID) {
		var postResult$ = new Subject();
		var url = "Staff/StaffIDInUse?StaffID=" + StaffID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StaffGetData(PersonID) {
		var postResult$ = new Subject();
		var url = "Staff/StaffGetData?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StationReminderInfoSelectList(ScanID) {
		var postResult$ = new Subject();
		var url = "Scans/StationReminderInfoSelectList?ScanID=" + ScanID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
